// The X menu to be displayed in title bars.
import React from 'react';
import SvgIcon from './svg-icon.jsx';

export default class MenuCancel extends React.PureComponent {
  render() {
    return (
      <a href="#" onClick={(e) => {e.preventDefault(); this.props.onCancel();}}>
        <SvgIcon name="close" viewBox="0 0 19 19" className="icon-close" />
      </a>
    );
  }
}
